// extracted by mini-css-extract-plugin
export default {"card":"iY-z","carouselContainer":"jY-z","carouselContent":"kY-z"};